import { downloadCSV } from '@helpers/downloadCSV';
import { formatCentsPrice } from '@helpers/formatCentsPrice';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { TransactionRow } from '../types/TransactionRow';

const headers = [
  'ID',
  'Created',
  'Title',
  'Charge ID',
  'Amount',
  'Transaction Code',
  'Type',
  'Receipt Url',
  'Associated Job',
  'Billing Account ID',
  'Billing Account Name',
];

type TOptions = {
  billingAccountId: string;
  billingAccountName: string;
};

export const downloadBillingScopedTransactionsCsv = (
  transactions: TransactionRow[],
  { billingAccountId, billingAccountName }: TOptions,
) => {
  const array = transactions.map((data) => ({
    id: data.id,
    created: getAmericanTime(data.createdAt),
    title: data.title,
    chargeId: data.stripeChargeId ?? data.id,
    amount: formatCentsPrice(data.amount ?? 0),
    code: data.codeId,
    type: data.code?.status ?? data.codeId,
    receiptUrl: data.stripeReceiptUrl ?? '',
    associatedJob: data.jobId ?? '',
    billingAccountId,
    billingAccountName,
  }));
  return downloadCSV(array, headers);
};
